<template>
  <div id="youtube">
    <v-form ref="youtubeForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
        <v-flex class="xs12">
        <h5 class="pf-sub-head mb-3 mt-4 custom-title">
            <b> YouTube Channel </b>
        </h5>
        </v-flex>
        <v-flex class="xs12 sm6 md7 mb-3 mt-3">
        <v-btn class="pf-btn pf-btn-save ml-0" @click="config" v-if="!agencyData.youtube.status">
            <v-icon size="16" class="pr-1">fas fa-cog</v-icon>
            <div> Configure YouTube </div>
        </v-btn>
        <v-text-field v-if="agencyData.youtube.status" disabled label="Channel ID" v-model="agencyData.youtube.channel_id"></v-text-field>
        <v-btn class="pf-btn pf-btn-save ml-0" @click="unConfig" v-if="agencyData.youtube.status">
            <v-icon size="16" class="pr-1">fas fa-cog</v-icon>
            <div> Unlink YouTube </div>
        </v-btn>
        </v-flex>  
      </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session store config */
import { remove, request } from '../helpers/helpers';
import swal from 'sweetalert2';

export default {
  data: () => ({
    entity: 'Agency',
    agencyData: {},
  }),
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  created () {
    this.agencyData = Object.assign({}, this.Agency);
    if (!this.agencyData.youtube) {
      this.agencyData.youtube = {};
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async config () {
      let { error, data } = await request('Agency/YoutubeLink?agency=' + this.Agency.id, 'GET');
      if (error) {
        console.log('error', error);
      } else {
        window.location.href = data.authorizeUrl;
      }
    },
    async unConfig () {
      swal.fire({
        title: 'Are you sure?',
        text: `You want to unlink configuration!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Agency', 'YoutubeLink');
            if (error) {
              console.log('error', error);
            } else {
              swal.fire(
                `Unlinked configuration successfully`
              );
              this.Agency = data;
              this.agencyData.youtube = data.youtube;
            }
          })();
        }
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Youtube.vue